import { ClickAway } from '@components/core-ui/ClickAway';
import { Fragment } from 'react';

import { TProps } from './types/TProps';

export const DropDown = ({ options, close }: TProps) => (
  <ClickAway onClickAway={close}>
    <div className="dropdown absolute right-2.5 top-[45px] z-[10000] w-max overflow-hidden rounded-[5px] border border-[var(--color-border)] bg-[var(--color-surface)] shadow-[0_10px_15px_var(--color-shadow)]">
      {options?.map((option, index) => (
        <Fragment key={index}>
          <div
            className="option w-full cursor-pointer p-2.5 font-['General_Sans',sans-serif] text-sm font-medium capitalize leading-[150%] text-[var(--color-text-muted)] hover:bg-[var(--color-surface-muted)]"
            onClick={option.onClick}
            data-testid={option.testId}
          >
            {option.title}
          </div>
          {index + 1 < options?.length && (
            <div className="option-divider mx-2.5 border-b border-[var(--color-border)]" />
          )}
        </Fragment>
      ))}
    </div>
  </ClickAway>
);
